<!-- <app-page-nav></app-page-nav> -->
<app-join-community></app-join-community>
<app-footer></app-footer>